module.exports = __webpack_public_path__ + "img/img5.45cd4046.png";